/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class GoPayCommonsService {

  public textTokens: any = undefined;
  private _textTokens$: Observable<any> | null = null;
  private readonly _http = inject(HttpClient);

  public getTextTokens(): Observable<any> {
    if (this.textTokens) {
      return of(this.textTokens);
    }
    if (!this._textTokens$) {
      this._textTokens$ = this._http.get('assets/commons/go-pay-commons.json').pipe(
        tap(data => this.textTokens = data),
        shareReplay(1)
      );
    }
    return this._textTokens$;
  }

}
